<template>
  <div>
    <van-nav-bar left-text="" :title="t('entrada.title')" class="custom-nav-bar" :border="false"
      >
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
  </div>

  <div class="m-[15px]">
    <div class="vipsstyle">
      <img :src="getLevelIcon(currentUserLevel?.level || 0)" alt="" class="w-[170px] h-[120px] mt-[8px]">
      <div class="mt-[45px] font-bold text-[24px] color-[#fff]">{{ currentUserLevel?.levelName ||
        t('entrada.apprentice') }}</div>
    </div>
    <div>
      <div class="flex items-center justify-center mt-[10px]  justify-between">
        <div v-for="(item, index) in userLevelInfoList" :key="index" class="flex flex-col items-center">
          <div class="flex items-center justify-center"
            :class="currentUserLevel?.level === item.level ? 'vipactive' : 'vipstyles'">
            <img :src="getLevelIcon(item.level)" alt="" class="w-[39px] h-[27px]">
          </div>
          <div class="color-[#60B38A] text-[12px] mt-[9px]">{{ item.levelName }}</div>
        </div>
      </div>
    </div>
    <div class="progress-bar-wrap">
      <div class="progress-bar-track">
        <div class="progress-bar-fill" :style="{ width: getProgressWidth() + '%' }"></div>
        <div v-for="(item, idx) in userLevelInfoList" :key="idx" class="progress-bar-step"
          :style="{ left: (idx / (userLevelInfoList.length - 1)) * 100 + '%' }">
          <div class="progress-bar-dot" :class="{
            active: idx <= getCurrentLevelIndex(),
            current: idx === getCurrentLevelIndex()
          }"></div>
          <div class="progress-bar-label" :class="{ active: idx <= getCurrentLevelIndex() }">{{
            formatAmount(item.betAmount) }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="monestyle">
    <div class="color-[#ECF949] text-[24px] font-bold">{{ VITE_symbol }} {{ formatAmount(betAmount) }}</div>
    <div class="color-[#2E8F5C] text-[12px] mt-[3px]">{{ t('entrada.lastDays', { days: betTime || 0 }) }}</div>
  </div>
  <div class="viptables">
    <div class="flex  items-center justify-center bg-[#1F6749] h-[58px] rounded-t-[8px]">
      <img :src="getAssetsFile('activity/icon1-C17WfzLG@2x.png')" alt="" class="w-[32px] h-[19px]">
      <div class="color-[#60B38A] text-[16px] ml-[12px]">{{ t('entrada.rewardInfo') }}</div>
    </div>
    <div v-for="(item, idx) in getRewardList()" :key="item.day"
      class="grid grid-cols-3 items-center my-[10px] reward-row" :class="{ 'zebra': idx % 2 === 1 }">
      <!-- 第一列：天数 -->
      <div class="flex items-center ml-[15px]">
        <img :src="getAssetsFile('activity/icon2-CrPRB5aO@2x.png')" alt="" class="w-[19px] h-[20px]">
        <div class="color-[#60B38A] text-[15px] ml-[12px]">{{ t('entrada.day') }} {{ item.day }}</div>
      </div>

      <!-- 第二列：金额 - 左对齐并添加左边距 -->
      <div class="flex items-center justify-start pl-[10px]">
        <div class="color-[#24784D] text-[15px]">{{ VITE_symbol }}</div>
        <div class="color-[#F1FD49] text-[15px] ml-[6px]">{{ item.amount }}</div>
      </div>

      <!-- 第三列：状态 -->
      <div class="color-[#60B38A] text-[15px] mr-[15px] text-center">
        <div>{{ getStatusText(item.status) }}</div>
      </div>
    </div>
  </div>
  <div class="color-[#BACBC3] text-[12px]" style="margin: 11px 15px 0 25px;">
    <div class="color-[#BACBC3] text-[14px] font-bold">
      {{ t('entrada.activityRules') }}
    </div>
    <p>{{ t('entrada.rule1') }}</p>
    <p>{{ t('entrada.rule2') }}</p>
    <p>{{ t('entrada.rule3') }}</p>
    <p>{{ t('entrada.rule4') }}</p>
    <p>{{ t('entrada.rule5') }}</p>
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n'
import { ref, computed, onMounted } from 'vue'
import { getActivity } from '@/api/game'
import { numberFormat } from '@/utils/formatter'
import { getAssetsFile } from '@/utils/pub-use'
const { t } = useI18n()
const router = useRouter();
// 接口数据
const userLevelInfoList = ref([])
const betAmount = ref(0)
const signDay = ref(0)
const betTime = ref(0)

// 计算当前用户等级 - 根据投注金额判断当前等级
const currentUserLevel = computed(() => {
  // 根据 betAmount 找到对应的等级
  for (let i = userLevelInfoList.value.length - 1; i >= 0; i--) {
    if (betAmount.value >= userLevelInfoList.value[i].betAmount) {
      return userLevelInfoList.value[i]
    }
  }
  // 如果都不满足，返回最低等级
  return userLevelInfoList.value[0] || {}
})

// 获取等级图标
const getLevelIcon = (level: number) => {
  const icons = [
    getAssetsFile('activity/V0-BWUPmnKG@2x.png'), // V0 (level 0)
    getAssetsFile('activity/V1-BFWYlNWL@2x.png'), // V1 (level 1)
    getAssetsFile('activity/V2-CyQDazyx@2x.png'), // V2 (level 2)
    getAssetsFile('activity/V3-DR-nbSRr@2x.png'), // V3 (level 3)
    getAssetsFile('activity/V4-BP-ubmzU@2x.png'), // V4 (level 4)
    getAssetsFile('activity/V5-SE8egUNl@2x.png'), // V5 (level 5)
  ]
  return icons[level] || icons[0]
}

// 获取当前等级在数组中的索引
const getCurrentLevelIndex = () => {
  const currentLevel = currentUserLevel.value?.level || 0
  return userLevelInfoList.value.findIndex(level => level.level === currentLevel)
}

// 计算进度条宽度
const getProgressWidth = () => {
  const currentIndex = getCurrentLevelIndex()
  if (currentIndex === -1) return 0
  if (currentIndex === userLevelInfoList.value.length - 1) return 100 // 最高等级显示100%
  return (currentIndex / (userLevelInfoList.value.length - 1)) * 100
}

// 格式化金额 - 确保显示 .00
const formatAmount = (amount: number) => {
  return amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// 获取奖励列表
const getRewardList = () => {
  // 如果当前等级是0（没有配置），取所有等级里最大的那个
  let targetLevel = currentUserLevel.value

  if (!targetLevel || targetLevel.level === 0) {
    // 找到所有等级中最大的那个
    targetLevel = userLevelInfoList.value.reduce((max, current) => {
      return current.level > max.level ? current : max
    }, userLevelInfoList.value[0] || {})
  }

  if (!targetLevel?.rewardList) return []

  return targetLevel.rewardList.map((reward, index) => ({
    day: index + 1,
    amount: formatAmount(reward),
    status: getRewardStatus(index + 1)
  }))
}

// 获取奖励状态
const getRewardStatus = (day: number) => {
  if (day <= signDay.value) {
    return 'claimed' // 已领取
  } else {
    return 'noRewards' // 无奖励
  }
}

// 添加状态判断函数
const getStatusText = (status: string) => {
  switch (status) {
    case 'claimed':
      return t('entrada.signedIn') // 已签到
    case 'noRewards':
    default:
      return t('entrada.noRewards') // 无奖励
  }
}

const VITE_symbol = import.meta.env.VITE_SYMBOL

const onClickLeft = () => {
  router.back()
}

onMounted(() => {
  getActivity().then(res => {
    console.log('接口数据:', res.data)

    // 设置接口数据
    userLevelInfoList.value = res.data.userLevelInfoList || []
    betAmount.value = res.data.betAmount || 0
    signDay.value = res.data.signDay || 0
    betTime.value = res.data.betTime || 0

    console.log('用户等级列表:', userLevelInfoList.value)
    console.log('当前用户等级:', currentUserLevel.value)
    console.log('投注金额:', betAmount.value)
    console.log('签到天数:', signDay.value)
  }).catch(error => {
    console.error('获取活动数据失败:', error)
  })
})
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
.vipsstyle {
  height: 197px;
  background: getPath('activity/banner01-D4JvzT0X@2x.png') no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.vipstyles {
  width: 46px;
  height: 47px;
  background: #18553A;
  border-radius: 7px;

}

.vipactive {
  background: linear-gradient(0deg, #389757 0%, #43C46B 100%);
  width: 46px;
  height: 47px;
  border-radius: 7px;
}

.progress-bar-wrap {

  margin: 22px 27px 0 20px;
  /* 将左边距从15px增加到20px */
  position: relative;
}

.progress-bar-track {
  position: relative;
  height: 12px;
  /* 让容器高度足够 */

}

.progress-bar-fill {
  position: absolute;
  top: 4.5px;
  /* 和底轨道对齐 */
  left: 0;
  height: 3px;
  background: #60B38A;
  z-index: 1;
  transition: width 0.3s;
}

.progress-bar-track::before {
  content: '';
  position: absolute;
  top: 4.5px;
  left: 0;
  right: 0;
  height: 3px;
  width: 100%;
  background: #18553A;
  border-radius: 1.5px;
  z-index: 0;
}

.progress-bar-step {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  text-align: center;
  z-index: 2;
  pointer-events: none;
}

.progress-bar-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(96, 179, 138, 0.2);
  /* 未激活为淡绿色 */
  border: 2px solid rgba(96, 179, 138, 0.4);
  /* 未激活为淡绿色边框 */
  margin: 0 auto;
  transition: background 0.3s, border 0.3s;
  box-sizing: border-box;
}

.progress-bar-dot.active {
  background: #60B38A;
  border: 2px solid #43C46B;
}

.progress-bar-label {
  margin-top: 2px;
  color: rgba(96, 179, 138, 0.4);
  /* 未激活为淡绿色 */
  font-size: 10px;
  font-weight: 700;
  opacity: 1;
  transition: color 0.3s;
  line-height: 1;
}

.progress-bar-label.active {
  color: #60B38A;
}

.monestyle {
  height: 58px;
  background: #1F6749;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 31px 15px 0 15px;

}

.viptables {
  background: #18553A;
  border-radius: 8px;
  margin: 11px 15px 0 15px;
  border-radius: 8px;
}

.reward-row.zebra {
  background: rgba(255, 255, 255, 0.05);
}
</style>
<route lang="json5">
    {
      name: 'entrada',
      meta: {
        title: 'entrada',
        i18n: 'menus.entrada'
      },
    }
    </route>
